module.exports = __webpack_public_path__ + "1_0_64/img/fresh.9202b52f.png";